import React, { Component } from "react";

export default class NotFound extends Component {
  render() {
    return (
      <div>
        <div
          style={{
            height: "calc(100vh - 50px)",
            position: "fixed",
            width: "100vw",
            backgroundColor: "#A2AAB6",
            pointerEvents: "none",
          }}
        />
        <p
          style={{
            color: "white",
            fontSize: "2rem",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        >
          404 - Not Found
        </p>
      </div>
    );
  }
}
